/**
 * set equal height to child elements of all slides
 */
function vzEqualizeHeadings() {
  const archiveRows = document.querySelectorAll(".post-grid");

  if (archiveRows.length == 0) return;

  const elementLists = [];

  for (const row of archiveRows) {
    const titles = row.querySelectorAll(".title");

    if (titles.length) {
      elementLists.push(titles);
    }

    const postTags = row.querySelectorAll(".post-tags");
    if (postTags.length) {
      elementLists.push(postTags);
    }
  }

  if (Foundation.MediaQuery.is("small only")) {
    elementLists.forEach((list) => {
      vzEqualizeResetHeight(list);
    });
    return;
  }

  elementLists.forEach((list) => {
    vzEqualizeResetHeight(list);
    const maxHeight = vzEqualizeGetMaxHeight(list);
    vzEqualizeSetHeight(list, maxHeight);
  });
}

/**
 * removes height property of elements' styles
 * @param {NodeList} elementList
 */
function vzEqualizeResetHeight(elementList) {
  for (const element of elementList) {
    element.style.removeProperty("height");
  }
}

/**
 * get greatest height of given elements
 * @param {NodeList} elementList
 * @returns {Number}
 */
function vzEqualizeGetMaxHeight(elementList) {
  let maxHeight = 0;
  for (const element of elementList) {
    const height = element.clientHeight;
    maxHeight = Math.max(height, maxHeight);
  }
  return maxHeight;
}

/**
 * set height of given elements
 * @param {NodeList} elementList
 * @param {Number} height
 * @returns
 */
function vzEqualizeSetHeight(elementList, height) {
  if (!Number.isInteger(height)) return;

  for (const element of elementList) {
    element.style.height = `${height}px`;
  }
}

